import moment from "moment"
import { BillingGroupType, InvoiceType } from "../types"

export const createSignature = (currentBillingGroup: BillingGroupType) => {        
    return {__html: currentBillingGroup.EmailSignature ?? ""}   
}

export const createMessage = (currentBillingGroup: BillingGroupType) => {
    return {__html: currentBillingGroup.EmailMessage ?? "" }
}

export const createSubject = (currentBillingGroup: BillingGroupType, currentInvoice: InvoiceType) => {        
    return `ELM INVOICE ${currentInvoice.InvoiceNumber} - WEEK ENDING ${moment(currentInvoice.WeekEnding).format('MM-DD-YYYY')}`
}